import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CalendarCheck, CheckCircle2, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errorMessage } from "@/lib/api";
import { formatDate } from "@/lib/services";
import { AuthShell, FormError } from "@/components/auth/AuthShell";

export default function ConfirmVisit() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/public/visit", { params: { token } }).then((r) => setInfo(r.data)).catch((e) => setError(errorMessage(e)));
  }, [token]);

  const confirm = async () => {
    setBusy(true);
    setError("");
    try { setInfo((await api.post("/public/visit/confirm", { token })).data); } catch (e) { setError(errorMessage(e)); } finally { setBusy(false); }
  };

  return (
    <AuthShell title="Confirmação de visita" testid="confirm-visit-page">
      {!info && !error && <Loader2 className="h-6 w-6 animate-spin text-slate-400" data-testid="confirm-visit-loading" />}
      {error && <FormError error={error} />}
      {info && (
        <div className="space-y-4">
          <div className="rounded-xl border border-slate-700 bg-slate-950/50 p-4 text-sm" data-testid="confirm-visit-details">
            <p className="text-slate-400">{info.company}</p>
            <p className="mt-1 text-lg font-semibold text-slate-100">{info.service_name}</p>
            <p className="mt-1 flex items-center gap-2 text-slate-200"><CalendarCheck className="h-4 w-4" /> {formatDate(info.date)}</p>
            <p className="mt-1 text-xs text-slate-500">Cliente: {info.client_name}</p>
          </div>
          {info.confirmed ? (
            <p className="flex gap-2 text-sm text-emerald-200" data-testid="confirm-visit-done"><CheckCircle2 className="h-5 w-5 shrink-0" /> Visita confirmada. Obrigado!</p>
          ) : info.changed ? (
            <p className="text-sm text-amber-200" data-testid="confirm-visit-changed">A data desta visita mudou. Fale com {info.company || "a empresa"}{info.company_phone ? ` pelo ${info.company_phone}` : ""}.</p>
          ) : (
            <Button onClick={confirm} disabled={busy} className="h-11 w-full rounded-full font-semibold" data-testid="confirm-visit-button">
              {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Confirmar visita
            </Button>
          )}
        </div>
      )}
    </AuthShell>
  );
}
